import React, { useRef } from 'react';
import Webcam from 'react-webcam';
import './CameraCapture.scss';
import CustomButton from '../customButton';

const videoConstraints = {
  width: 320,
  height: 240,
  facingMode: 'user',
};

const CameraCapture = ({ photo, setPhoto ,handleConfirmPhoto}) => {
  const webcamRef = useRef(null);

  const capture = () => {
    const imageSrc = webcamRef.current?.getScreenshot();
    setPhoto(imageSrc || null);
  };

  return (
    <div className="camera-wrapper">
      {!photo ? (
        <>
          <Webcam
            audio={false}
            ref={webcamRef}
            screenshotFormat="image/jpeg"
            videoConstraints={videoConstraints}
          />
          <CustomButton onClick={capture}>Capture Photo</CustomButton>
        </>
      ) : (
        <div className="preview">
          <h4>Captured Photo:</h4>
          <img src={photo} alt="Captured" />
          <div className="" style={{ display: 'flex', gap: "20px", marginTop: '10px' }}>
            <CustomButton onClick={() => setPhoto(null)}>Retake</CustomButton>
            <CustomButton color="green" onClick={handleConfirmPhoto}>Use Photo</CustomButton>

          </div>

        </div>
      )}
    </div>
  );
};

export default CameraCapture;
